<div class="table-responsive">
  <table
    id="data-table"
    class="table text-nowrap m-0 table-bordered table-striped"
    >
    @if (list.length > 0 && !showLoading) {
      <thead class="table-head">
        <tr class="text-secondary bg-gray-200">
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('EnrollmentNo')"
            (click)="applySort('EnrollmentNo')">
            MEMBER ID
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySortPatient('patientname')"
            [ngClass]="renderArrowIcon('patientname')">
            PATIENT
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySortPatient('nephrologist')"
            [ngClass]="renderArrowIcon('nephrologist')">
            NEPHROLOGIST
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('BirthDate')"
            [ngClass]="renderArrowIcon('BirthDate')">
            DOB (AGE)
          </th>
          <th class="bg-transparent border-bottom-0 no-btn fs-12 wp-3"></th>
        </tr>
      </thead>
    }
    @if (showLoading) {
      <tbody class="table-body">
        @for (i of getIterations(); track i) {
          <tr>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
          </tr>
        }
      </tbody>
    }
    @if (!showLoading) {
      <tbody class="table-body">
        @for (item of list; track item) {
          <tr>
            <td>
              <div class="d-flex align-items-center">
                <div class="user-details ms-2">
                  <a
                    class="text-secondary"
                    href="javascript: void(0)"
                    (click)="patientHandler(item, 'detail')"
                    ><h6 class="mb-0">{{ item.patient?.enrollmentNo }}</h6></a
                    >
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i data-bs-toggle="tooltip" data-bs-placement="top" [title]="item.isRegistered ? 'Registered on MySomatus' : 'Not Registered on MySomatus'" class="fa" [ngClass]="!item.isRegistered ? 'fa-times-circle text-danger' : 'fa-check-circle text-success'"></i>
                  <div class="user-details ms-2">
                    <a
                      class="text-secondary"
                      href="javascript: void(0)"
                      (click)="patientHandler(item, 'detail')"
                      ><h6 class="mb-0">{{ item.patient?.name }}</h6></a
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="user-details ms-2">
                      {{ item.nephrologistName ? item.nephrologistName : '-' }}
                    </div>
                  </div>
                </td>
                <td class="d-flex align-items-center">
                  {{ getFormatDate(item.dob)
                  }}<strong class="fw-semibold"> ({{ getAge(item.dob) }})</strong>
                </td>
                <td class="text-center">
                  <a
                    href="#"
                    class="br-5 px-2 py-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    ><i class="fe fe-more-vertical"></i
                  ></a>
                  <div class="dropdown-menu dropdown-menu-start">
                    <!-- <a class="dropdown-item" href="#/patient-profile"
                    ><i class="fe fe-edit-2 me-2"></i> Edit</a
                    > -->
                    <a
                      class="dropdown-item"
                      href="Javascript: void(0);"
                      (click)="patientHandler(item, 'detail')"
                      ><i class="fe fe-info me-2"></i> Detail</a
                      >
                      @if (item.carePlanStatus === '1') {
                        <a
                          class="dropdown-item"
                          href="Javascript: void(0);"
                          (click)="patientHandler(item, 'viewCarePlan')"
                          ><i class="fe fe-info me-2"></i> View Care Plan</a
                          >
                        }
                      </div>
                    </td>
                  </tr>
                }
                <!-- <tr *ngIf="list.length == 0 && !showLoading">
                <td>{{ message.noRecords }}</td>
              </tr> -->
            </tbody>
          }
        </table>
        @if (!showLoading && list.length > 0) {
          <div class="me-5 mt-4 mb-2 d-inline-block">
            <i class="fa fa-check-circle text-success fs-14"></i> Registered on MySomatus
          </div>
          <div class="me-5 mt-4 mb-2 d-inline-block">
            <i class="fa fa-times-circle text-danger fs-14"></i> Not Registered on MySomatus
          </div>
        }
        @if (list.length === 0 && !showLoading) {
          <app-no-records-found
          ></app-no-records-found>
        }
        @if (list.length > 0 && !showLoading) {
          <app-pagination
            [attributePatients]="attributePatients"
            [pagingModel]="gridData.pagingModel"
            (gotoPageHandler)="gotoPage($event)"
            >
          </app-pagination>
        }
      </div>
